import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import locationService from "../services/location.service";
import { Locationvalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
const Airconlocation = () => {
  const ref = useRef();
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");

  const [locations, setLocations] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "Building ID", value: "" },
    { label: "Building name", value: "building_name" },
    { label: "Address", value: "" },
    { label: "Status", value: "" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const formik = useFormik({
    initialValues: {
      location_id: "",
      client_id: searchParams.get("client_id"),
      location_name: "",
      location_address: "",
      location_status: "",
    },
    validationSchema: Locationvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallLocation();
  }, []);
  useLayoutEffect(() => {
    getallLocation();
  }, [page, limit, filter, search, between, sort]);

  //current event
  const locationEvent = (eventname, value) => {
    if (value != "") {
      getLocation(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    formik.resetForm();
  };
  //get alllocation
  const getallLocation = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: searchParams.get("client_id"),
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await locationService
      .getallLocation(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setLocations(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setLocations(null);
          ref.current.toastlog(res.data.status, res.data.message);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get location
  const getLocation = (value) => {
    setIsLoaded(true);
    locationService
      .getLocation(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            location_id: data.location_id,
            client_id: data.client_id,
            location_name: data.location_name,
            location_address: data.location_address,
            location_status: data.location_status,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create location
  const createLocation = () => {
    locationService
      .createLocation(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          getallLocation();
          formik.resetForm();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update location
  const updateLocation = (value) => {
    console.log(JSON.stringify(formik.values, null, 2));
    locationService
      .updateLocation(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallLocation();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete location
  const deleteLocation = (value) => {
    console.log(value);
    locationService
      .deleteLocation(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          formik.resetForm();
          getallLocation();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call location clicks to request another page.
  if (ismessage === "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="location-container">
        {/* location form */}
        <div className="card border-0 mb-2">
          <div className="card-body ">
            <div className="d-flex">
              <h5 className="card-title p-0 m-0 me-auto">Building</h5>
              {eventname == "create" ? (
                <></>
              ) : (
                <div className="d-none">
                  <div className="dropdown ">
                    <a
                      className="btn  btn-link"
                      href="#"
                      role="button"
                      id="locationeventdropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="locationeventdropdownMenuLink"
                    >
                      <li>
                        <a
                          onClick={() => {
                            locationEvent("edit", "");
                          }}
                          className="dropdown-item"
                        >
                          Edit
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() => locationEvent("delete", "")}
                          className="dropdown-item"
                        >
                          Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-4 ">
                  <label htmlFor="location_name" className="form-label">
                  Building name
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      placeholder="Enter Locationname"
                      id="location_name"
                      type="text"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                      {...formik.getFieldProps("location_name")}
                    />
                  </div>
                  <div>
                    {formik.touched.location_name &&
                    formik.errors.location_name ? (
                      <div className="error">{formik.errors.location_name}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-5 ">
                  <label htmlFor="location_address" className="form-label">
                  Building Address
                  </label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      placeholder="Enter address"
                      id="location_address"
                      type="text"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                      {...formik.getFieldProps("location_address")}
                    />
                  </div>
                  <div>
                    {formik.touched.location_address &&
                    formik.errors.location_address ? (
                      <div className="error">
                        {formik.errors.location_address}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="location_status" className="form-label">
                    status
                  </label>
                  <div className="input-group col-md-6">
                    <select
                      id="location_status"
                      {...formik.getFieldProps("location_status")}
                      className="form-select"
                      aria-label="location_status"
                      disabled={
                        eventname == "view"
                          ? true
                          : eventname == "delete"
                          ? true
                          : false
                      }
                    >
                      <option value="" disabled>
                        Select status
                      </option>
                      <option value="pending">Pending</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  <div>
                    {formik.touched.location_status &&
                    formik.errors.location_status ? (
                      <div className="error">
                        {formik.errors.location_status}
                      </div>
                    ) : null}
                  </div>
                </div>
                {/* location event buttons */}
                <div className="col-md-12 pt-2 pb-2">
                  {eventname === "create" ? (
                    <>
                      <button
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={() => createLocation()}
                        className="btn btn-primary me-2"
                      >
                        Create
                      </button>
                      <button
                        disabled={!formik.dirty}
                        onClick={formik.handleReset}
                        className="btn btn-secondary"
                      >
                        Clear
                      </button>
                    </>
                  ) : eventname === "edit" ? (
                    <>
                      <button
                        onClick={() => updateLocation()}
                        className="btn btn-primary me-2"
                      >
                        Update
                      </button>
                      <a
                        onClick={() => {
                          locationEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-secondary"
                      >
                        Cancel
                      </a>
                    </>
                  ) : eventname === "delete" ? (
                    <>
                      <button
                        onClick={() =>
                          deleteLocation(formik.values.location_id)
                        }
                        className="btn btn-danger me-2 "
                      >
                        Delete
                      </button>
                      <a
                        onClick={() => {
                          locationEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-secondary"
                      >
                        Cancel
                      </a>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          locationEvent("create", "");
                          formik.handleReset();
                        }}
                        className="btn btn-primary"
                      >
                        Close
                      </button>
                    </>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex  mb-2 ">
          {/* create location */}
          {/*  <div className="m-1">
            <button
              onClick={() => {
                setEventname("create", "");
                formik.handleReset();
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> New
            </button>
          </div> */}
          {/* filter status*/}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Location Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className=" m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {tableHeaders.map((data, index) => (
                  <th key={index} scope="col">
                    {data.label}
                    {/* table sort */}
                    {data.value != "" ? (
                      <a
                        onClick={() => sortfn(data.value)}
                        className="btn btn-sm"
                      >
                        <span
                          className={
                            sort === data.value + " asc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={
                            sort === data.value + " desc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </a>
                    ) : (
                      <></>
                    )}
                  </th>
                ))}
                {/* <th scope="col">#</th>
                <th scope="col">location name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {/* table data */}
              {locations ? (
                <>
                  {locations.map((data, index) => (
                    <tr key={index}>
                      <td>{data.location_id}</td>
                      <td>{data.location_name}</td>
                      <td>{data.location_address}</td>
                      <td>
                        <span className={selectedcolor(data.location_status)}>
                          {data.location_status}
                        </span>
                      </td>
                      <td>{format(new Date(data.createdAt), "PPpp")}</td>
                      <td className="p-1 m-0">
                        <button
                          onClick={() =>
                            locationEvent("view", data.location_id)
                          }
                          className="btn btn-light me-2 "
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </button>
                        <button
                          onClick={() =>
                            locationEvent("edit", data.location_id)
                          }
                          className="btn btn-light me-2 "
                        >
                          <i
                            className="fa fa-pencil-square"
                            aria-hidden="true"
                          ></i>
                        </button>
                        <button
                          onClick={() =>
                            locationEvent("delete", data.location_id)
                          }
                          className="btn btn-light me-2 "
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    <div className="text-center p-3">0 data found</div>
                  </td>
                </tr>
              )}
            </tbody>
            <caption className="">
              <div className="d-flex">
                <div className="flex-fill"></div>
                <div className="p-1 "> Items per page </div>
                <div>
                  {" "}
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    className="form-select form-select-sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div>
                <div className="p-1 me-4">
                  {page * limit - limit}-{page * limit} of {resultCount}
                </div>
                <ReactPaginate
                  previousLabel="< Prev"
                  nextLabel="Next >"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pagecount}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={paginationfn}
                  containerClassName="pagination"
                  activeClassName="actives"
                  disabledLinkClassName="text-secondary"
                  forcePage={page - 1}
                />
              </div>
            </caption>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Airconlocation;
